<template>
  <div class="container pb-10">
    <div class="flex items-center mb-10">
      <a href="/admin/forms/request-inspection" class="text-gray-900 no-underline">
        <d-icon icon="arrow-left" size="1x" class="mr-3" />
        <span class="text-xl">Back To Listing Page</span>
      </a>
    </div>

    <h2>Submission Details</h2>
    <div class="flex -mx-5 relative">
      <div class="w-1/2 px-5">
        <div class="mb-3">
          <p class="font-bold">
            Contact First Name
          </p>
          <p v-text="computedSubmissionDetails.contactFirstName" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Contact Last Name
          </p>
          <p v-text="computedSubmissionDetails.contactLastName" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Company Name
          </p>
          <p v-text="computedSubmissionDetails.companyName" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Phone #
          </p>
          <p v-text="computedSubmissionDetails.phone" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Fax #
          </p>
          <p v-text="computedSubmissionDetails.fax" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Email
          </p>
          <p v-text="computedSubmissionDetails.email" />
        </div>
      </div>

      <div class="w-1/2 px-5">
        <div class="mb-3">
          <p class="font-bold">
            Project Name
          </p>
          <p v-text="computedSubmissionDetails.projectName" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            QCP Project Number
          </p>
          <p v-text="computedSubmissionDetails.qcpProjectNumber" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Reason For Request
          </p>
          <p v-text="computedSubmissionDetails.reasonForRequest" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Contact's Role
          </p>
          <ul class="list-disc list-inside">
            <li v-for="item in computedContactRole" :key="item" v-text="item" />
          </ul>
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Inspection Type
          </p>
          <ul class="list-disc list-inside">
            <li v-for="item in computedInspectionType" :key="item" v-text="item" />
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      submissionDetails: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      computedSubmissionDetails: {
        get() {
          return this.submissionDetails;
        },
        set(value) {
          this.$emit('submissionDetails:update', value);
        },
      },

      computedInspectionType() {
        return JSON.parse(this.computedSubmissionDetails.inspectionType);
      },

      computedContactRole() {
        return JSON.parse(this.computedSubmissionDetails.contactRole);
      },
    },
  };
</script>